import { Component, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';


@Component({
  selector: 'app-setting-integration',
  templateUrl: './setting-integration.component.html',
  styleUrls: ['./setting-integration.component.scss']
})
export class SettingIntegrationComponent implements AfterViewInit {
   
  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
    //this.company_uuid = this.http.getSelectedCompany();
   }

  ngAfterViewInit(): void {
    this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/setting-integration/list", data: {uuid: this.company_uuid}},
          disabled_pagenat: false,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Name', type: 'string', key: 'name'},
            {label: 'Provider', type: 'string', key: 'type'},
            {label: 'Mode', type: 'string', key: 'integration_mode'},
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + (this.company_uuid ? '/' + this.company_uuid : '/null') + "/setting-integration/form", hide: true}
          ]}
      this.tb.init(setting);
      this.cdr.detectChanges();
  }


}
